import {
    InventoryProductModel,
    InventoryProductPayload,
} from '../../../../types/InventoryProduct';
import { DBWriterLoggerFunction } from '../../../../types/logger';

export const prepareUpdateInventoryProduct = ({
    inventoryProductElement,
    payload,
    userId,
    organisationID,
}: {
    inventoryProductElement: InventoryProductModel;
    payload: InventoryProductPayload;
    userId: string;
    organisationID: string;
}) =>
    inventoryProductElement.prepareUpdate((inventoryProduct) => {
        inventoryProduct.productId = payload.productId;
        inventoryProduct.userId = userId;
        inventoryProduct.organisationId = organisationID;
        inventoryProduct.quantity = payload.quantity;
    });

export const logUpdateInventoryProductAction = ({
    inventoryProductElement,
    logDBAction,
    tableName,
}: {
    inventoryProductElement: InventoryProductModel;
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Update inventory product',
        modelName: tableName,
        payload: inventoryProductElement,
    });
};
